import React from "react";
import PaytmEDCMachineConfig from "../../components/PaytmEDCMachineConfig/paytmedcmachineconfig.component";

export default class PaytmEDCMachineConfigScreen extends React.Component {
  render() {
    return <PaytmEDCMachineConfig />;
  }
}
